import React from 'react';
import { EnvironmentOutlined } from '@ant-design/icons';
import { TbPlane } from 'react-icons/tb';

export const AirportElement = ({ data }: { data: any }) => {
  return (
    <div
      className={`auto-complete-airport-element ${
        data?.type === 'airport' ? 'indented' : ''
      }`}
    >
      <div className="type-icon-wrapper">
        {data?.type === 'city' && <EnvironmentOutlined />}
        {data?.type === 'airport' && <TbPlane />}
      </div>
      <div className="element-info-wrapper">
        <span className="name">{`(${data?.iata_code}) ${data?.name}`}</span>
        {data.country && <span className="description">{data.country}</span>}
      </div>
    </div>
  );
};
